import React from 'react'
import {useTheme} from '@material-ui/core'
import MUICheckbox, {CheckboxProps as MUICheckboxProps} from '@material-ui/core/Checkbox'
import {FormControlLabel} from 'src/components/formControlLabel'
import {InactiveCheckboxUnchecked, InactiveCheckboxChecked} from 'src/components/icons'
import {makeStyles} from '@material-ui/core/styles'
import {color} from '../..'

export interface CheckboxProps extends MUICheckboxProps {
	label?: React.ReactNode
	disabled?: boolean
	onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
	checked: boolean
	testId?: string
}

const CheckedCheckbox = (props: React.SVGProps<SVGSVGElement>) => {
	const theme = useTheme()
	return (
		<svg
			width={16}
			height={16}
			fill={theme?.palette?.secondary?.main || '#3FD899'}
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<rect width={16} height={16} rx={4} />
			<path
				d='M12.5 4.25c-2.391 1.978-4.98 4.483-6.007 7.5H6.2C5.75 10.386 4.625 9.364 3.5 8.838'
				stroke={theme?.palette?.secondary?.contrastText || '#fff'}
				strokeWidth={1.5}
			/>
		</svg>
	)
}

const UncheckedCheckbox = (props: React.SVGProps<SVGSVGElement>) => {
	const theme = useTheme()
	return (
		<svg width={16} height={16} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<rect
				x={0.75}
				y={0.75}
				width={14.5}
				height={14.5}
				rx={3.25}
				stroke={theme?.palette?.text?.background || '#CFCDD3'}
				strokeWidth={1.5}
			/>
		</svg>
	)
}

const useStyles = makeStyles(() => ({
	root: {
		padding: 0,
		margin: '12px',

		'&:hover': {
			backgroundColor: 'transparent',
		},
		'&:focus-within': {
			boxShadow: `0 0 0 3pt ${color.blue700} !important`,
			borderRadius: '4px',
		},
	},
}))

export const Checkbox: React.FC<CheckboxProps> = (props: CheckboxProps) => {
	const {label, disabled, onChange, checked, testId = 'default-check-box', ...rest} = props
	const classes = useStyles()
	const dataTestId = disabled ? `${testId}-disabled` : checked ? `${testId}-checked` : `${testId}-unchecked`

	return (
		<FormControlLabel
			control={
				<MUICheckbox
					classes={{root: classes.root}}
					data-testid={dataTestId}
					icon={disabled ? <InactiveCheckboxUnchecked /> : <UncheckedCheckbox />}
					checkedIcon={disabled ? <InactiveCheckboxChecked /> : <CheckedCheckbox />}
					disableRipple={true}
					disabled={disabled}
					onChange={onChange}
					checked={checked}
					{...rest}
				/>
			}
			label={label}
			disabled={disabled}
		/>
	)
}
